module.exports = __webpack_public_path__ + "img/Dental3d_3.da8968c6.png";